import { useEffect, useState } from "react";

import _ from "lodash";
import Schemas from "schemas";
import * as yup from "yup";

import useQueryParams from "./useQueryParams";

import { dormitoryQuestionnaireSteps as steps } from "constants/config";

import { ESteps } from "types/enums";

export const getDormitoryCompletnessProgress = async (data: Object) => {
    const newProgress = Object.fromEntries(
        (
            await Promise.all(
                _.values(ESteps).map(async (i) => {
                    try {
                        await Schemas.dormitory[i](yup, data).validate(data);
                        return true;
                    } catch (error) {
                        return false;
                    }
                }),
            )
        ).map((i: boolean, j: number) => [_.values(ESteps)[j], i]),
    );
    return newProgress;
};

const useStepsOptions = (data: Object) => {
    const { params = {}, setByKey } = useQueryParams();
    const { step } = params as { step: ESteps };

    const [progress, setProgress] = useState(Object.fromEntries(_.values(ESteps).map((i) => [i, true])));
    const [validatedAtLEastOneTime, setValidatedAtLeastOneTime] = useState(false);

    useEffect(() => {
        if (!Object.values(ESteps).includes(step)) setByKey("step", ESteps.MainInfo);
    }, [step]);

    // @ts-ignore
    useEffect(async () => {
        if (!_.isEmpty(data) || !validatedAtLEastOneTime) {
            const newProgress = await getDormitoryCompletnessProgress(data);
            setValidatedAtLeastOneTime(true);
            setProgress(newProgress);
        }
    }, [data]);

    return {
        currentStep: step,
        setCurrentStep: (step: ESteps) => setByKey(`step`, step),
        goToNextStep: () => setByKey("step", _.get(steps, `[${steps.findIndex((s) => s.name === step) + 1}].name`)),
        goToPrevStep: () => setByKey("step", _.get(steps, `[${steps.findIndex((s) => s.name === step) - 1}].name`)),
        progress,
        allDone: _.values(progress).every((i) => i) && _.values(progress).length > 0,
        allUndone: _.values(progress).every((i) => !i) && _.values(progress).length > 0,
    };
};

export default useStepsOptions;
